export const TypeNameBlockCalendly = 'ParagraphCalendlyBlock';

export interface IBlockCalendly {
  __typename: string;
  utm?: unknown;
}

export const ELEMENT_CALENDLY_ID = 'calendlyId';
